import {findRouteName} from "@/helpers/helpers"
import { interfacesMenus } from "@/components/interfaces-menus";
export default function auth({to, next, store}) {
    if (!store.getters['auth/loggedIn']) {
        //If user try access to url when is unauthenticated get path, activeInterface and permission for redirect after logging.
        let interfaceTo = null, itemMatch = null, permission = null;

        let interfaceMenu = interfacesMenus.find((interfaceMenu) => {
            itemMatch = findRouteName(to.name, interfaceMenu);
            if(itemMatch){
                return interfaceMenu;
            }
        })
        interfaceTo = interfaceMenu ? interfaceMenu.interface : null;
        permission = itemMatch ? itemMatch.permission : null;

        return next({name: 'login',  query: { redirect: to.fullPath, activeInterface: interfaceTo, permission: permission}});
    }

    return next()
}